// extracted by mini-css-extract-plugin
export default {"container":"field-readonly_container__Mx9Vs","invert":"field-readonly_invert__yP4KE","label":"field-readonly_label__ALEmH","inline":"field-readonly_inline__8JyZd"};